export const CASE_TYPES = [
  { code: "auto",                  label: "Auto Accident" },
  { code: "truck",                 label: "Truck Accident" },
  { code: "motorcycle",            label: "Motorcycle Accident" },
  { code: "rideshare",             label: "Rideshare Accident" },
  { code: "public_transportation", label: "Public Transportation" },
  { code: "commercial_vehicle",    label: "Commercial Vehicle" },
  { code: "pedestrian",            label: "Pedestrian" },
  { code: "bicycle",               label: "Bicycle" },
  { code: "other",                 label: "Other Personal Injury" },
];

export const FAULT_LEVELS = [
  { code: "not_at_fault",       label: "Not at fault" },
  { code: "partially_at_fault", label: "Partially at fault" },
  { code: "mostly_at_fault",    label: "Mostly at fault" },
  { code: "fully_at_fault",     label: "Fully at fault" },
  { code: "not_sure",           label: "Not sure" },
];

export const LEAD_TYPES = [
  { code: "web_lead",                 label: "Web Lead" },
  { code: "cpql",                     label: "CPQL" },
  { code: "warm_transfer",            label: "Warm Transfer" },
  { code: "customer_initiated_call",  label: "Customer-Initiated Call" },
  { code: "signed_retainer",          label: "Signed Retainer" },
];

export const INCIDENT_AGE_PRESETS = [
  { value: null,  label: "No maximum" },
  { value: 30,    label: "30 days" },
  { value: 60,    label: "60 days" },
  { value: 90,    label: "90 days" },
  { value: 180,   label: "6 months" },
  { value: 365,   label: "1 year" },
  { value: "custom", label: "Custom…" },
];

export const TRISTATE_OPTIONS = [
  { value: "yes_required",   label: "Must be Yes" },
  { value: "no_required",    label: "Must be No" },
  { value: "no_requirement", label: "Doesn't matter" },
];
export const ATTORNEY_OPTIONS = [
  { value: "must_be_no",     label: "Must be No (not represented)" },
  { value: "allowed",        label: "Allowed (either OK)" },
  { value: "no_requirement", label: "Doesn't matter" },
];
export const HITRUN_OPTIONS = [
  { value: "accepted",       label: "Must be Yes (or unsure)" },
  { value: "rejected",       label: "Can't be Yes" },
  { value: "no_requirement", label: "Doesn't matter" },
];
export const AT_FAULT_INS_OPTIONS = [
  { value: "yes_required",     label: "Must be Yes" },
  { value: "no_required",      label: "Must be No" },
  { value: "unknown_accepted", label: "Yes or unsure" },
  { value: "no_requirement",   label: "Doesn't matter" },
];
